import {planTypes} from "@/common/constants";
import { getPlanLogo } from '@/common/plan-logo-map';
import { mapGetters } from 'vuex';

export default {
  key: planTypes[planTypes.VIDEO_SDK],
  data() {
    return {
      title:'',
      subtitle: '',
      planType: planTypes.VIDEO_SDK,
      logo: getPlanLogo(planTypes.VIDEO_SDK),
    }
  },
  computed: {
    ...mapGetters(['getTypeGroupSelectedPlans']),
    trackingPlanKey() {
      return this.trackingPlanName
    },
    selectedPlan() {
      return this.getTypeGroupSelectedPlans[this.planType]?.[0];
    },
    trackingPlanName(){
      return 'video sdk pay as you go'
    }
  },
  watch: {
    selectedPlan: {
      handler() {
        this.getDefaultTitles();
      },
      deep: true
    }
  },
  methods:{
    getDefaultTitles(){
      this.configDescription = this.$t('billing.video_sdk.desc')
      this.title = this.$t('billing.planform.title.video_sdk')
    },
  },
  created(){
    this.getDefaultTitles()
  }
};
